import React, { Component } from "react";

export default class SourceView extends Component {
  constructor(props) {
    super(props);
    this.state = {
        viewRecord:this.props.viewRecord,
        allPlans: props.plans || [],
    }
  }

  render() {
    return (
      <div className="customPopup" style={{ 'display': 'block' }}>
        <div className="bgLayer" />
        <div className="popUpBox" style={{ maxWidth: "770px" }}>
          <span className="closeIcon" onClick={this.props.togglePopUp}> </span>
          <div className="popScroll" style={{ padding: "20px 25px 16px 25px" }}>
            {
              //JSON.stringify(this.state.viewRecord, null, 2)
            }
            <div className="popUpHed">
              <h3>Source View</h3>
            </div>
            <div className="sourceView">
                <div className="row">
                    <div className="col-md-4">
                        <div className="infoRow">
                        <div className="key">Sequence No. </div>
                        <div className="val">{this.state.viewRecord.sequence}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="infoRow">
                        <div className="key">Source Key</div>
                        <div className="val"> {this.state.viewRecord.source_key}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="infoRow">
                        <div className="key">Vendor Name </div>
                        <div className="val">{this.state.viewRecord.vendor_name}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="infoRow">
                        <div className="key">Plans Type</div>
                        <div className="val">
                          {
                            (this.state.viewRecord.plan_type?.length > 0) ?
                              this.state.viewRecord.plan_type.map((tt,ind)=>{
                                let coma = ', ';
                                if(ind === 0) {
                                  coma = "";
                                }
                                let planObj = this.state.allPlans.filter((aa)=>(tt === aa.sr));
                                return (<span key={tt} className="sourceitem">{coma+planObj[0].key}</span>);
                              })
                            :
                            ''
                          }
                        </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="infoRow">
                        <div className="key">Price </div>
                        <div className="val">{this.state.viewRecord.price}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="infoRow">
                        <div className="key">Status </div>
                        <div className="val">
                          {
                            (this.state.viewRecord.status) ? 'Active' : 'InActive'
                          }
                        </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="infoRow">
                        <div className="key">Email </div>
                        <div className="val">{this.state.viewRecord.email}</div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="infoRow">
                        <div className="key">Contact Number </div>
                        <div className="val">{this.state.viewRecord.contact_no}</div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="infoRow">
                        <div className="key">URL </div>
                        <div className="val">{this.state.viewRecord.api_url}</div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="infoRow">
                        <div className="key">Token </div>
                        <div className="val">{this.state.viewRecord.token}</div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="infoRow">
                        <div className="key">CURL </div>
                          <div className="val">
                            <pre style={{"word-break": "break-all", "white-space":"pre-line"}}>{this.state.viewRecord.curl}</pre>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}